import { useEffect } from 'react';
import { DEFAULT_LOCALE, type ByLocale, type Locale } from '@superposition/domain';
import { useLocale } from '../lib/profile.js';
import { en } from './en.js';
import { ru } from './ru.js';

/**
 * тексты приложения. ключи и параметры задает русский словарь; английский
 * обязан повторить его форму, поэтому забытый ключ не соберется.
 */
export type Messages = typeof ru;

// английский выбирается, только если сервер открыл его флагом ENGLISH
const MESSAGES: ByLocale<Messages> = { ru, en };

export function messages(locale: Locale = DEFAULT_LOCALE): Messages {
  return MESSAGES[locale];
}

/** словарь на языке человека; меняется вместе с профилем */
export function useT(): Messages {
  return messages(useLocale());
}

/** <html lang> и заголовок вкладки следуют за языком профиля */
export function useDocumentLang(): void {
  const locale = useLocale();
  useEffect(() => {
    document.documentElement.lang = locale;
    document.title = messages(locale).common.documentTitle;
  }, [locale]);
}
